module.exports = __webpack_public_path__ + "img/test.633ec1b2.png";